//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import FilesGroup from '../../components/File/FilesGroup.js'
import FilesField from '../../components/File/FilesField.vue'
import StockInventoryRegradingRecordsInField from './StockInventoryRegradingRecordsInField.vue'
import { formatFieldAmountDiffRegrading, formatFieldDiffAmount, onInputAmountReal, units, onWithdrawWithThis, getToolRecordSurplusState } from './stockInventoryTools.js'
import { formatTime } from '../../components/helpers.js'
import ReportMaterialsImageBtn from '../Report/ReportMaterials/ReportMaterialsImageBtn.vue'

import StockInventoryToolField from './StockInventoryToolField.vue'

export default {
  components: {
    StockInventoryToolField,
    StockInventoryRegradingRecordsInField,
    ReportMaterialsImageBtn,
    FilesField
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    toolRecordStr: {
      type: String,
      default: null
    },
    additional: {
      type: Boolean,
      default: false
    },
    addSurplusTransferPhotos: {
      type: Boolean,
      default: false
    },
    toolRecord: {
      type: Object,
      default: function () {
        return {
          id: Date.now(),
          tool: null,
          amountRecorded: null,
          unit: null
        }
      }
    },
    additionToolRecordColumns: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    const vm = this

    return {
      amountRealOldValue: null,
      toolRecords: [],
      regradingRecords: [],
      loading: false,

      formatFieldAmountDiffRegrading: formatFieldAmountDiffRegrading,
      formatFieldDiffAmount: formatFieldDiffAmount,
      onInputAmountReal: onInputAmountReal,
      units: units,
      formatTime: formatTime,
      filesGroup: new FilesGroup({
        categoryKey: 'stockInventory',
        sourceConfig: {
          get preloadFormId () {
            const requestId = vm.record.request && vm.record.request.id
            const toolUniqueKey = vm.toolRecord && vm.toolRecord.tool && vm.toolRecord.tool.uniqueKey || null
            return requestId + '_' + (toolUniqueKey != null ? ('_' + toolUniqueKey) : '')
          },
          // objectId: this.record.request && this.record.request.id,
          uploadURL: '/service/delta/document/upload',
          removeURL: '/service/delta/document/deleteFromObject',
          removeDelayed: true,
          removeExternal: true // false
        }
      }),
      surplusTransferFilesGroup: new FilesGroup({
        categoryKey: 'stockInventorySurplusTransfer',
        sourceConfig: {
          get preloadFormId () {
            const requestId = vm.record.request && vm.record.request.id
            const toolUniqueKey = vm.toolRecord && vm.toolRecord.tool && vm.toolRecord.tool.uniqueKey || null
            return requestId + '_' + (toolUniqueKey != null ? ('_' + toolUniqueKey) : '')
          },
          // objectId: this.record.request && this.record.request.id,
          uploadURL: '/service/delta/document/upload',
          removeURL: '/service/delta/document/deleteFromObject',
          removeDelayed: true,
          removeExternal: true // false
        }
      })
    }
  },
  computed: {
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    requestProperties: function () {
      return this.record.requestProperties
    },
    request: function () {
      return this.record.request
    },
    propertyConfig: function () {
      return this.record.requestProperties.toolRecords
    },
    accessEditTool: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.resultEditable
    },
    toolRecordsWithdrawAvailable: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.withdrawAvailable
    },
    toolRecordsWithdrawAccess: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.withdrawAccess && this.toolRecordsWithdrawAvailable
    },
    surplusTransferAvailable: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.surplusTransferAvailable
    },
    surplusTransferAccess: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.surplusTransferAccess && this.surplusTransferAvailable
    },
    surplusTransferConfirmationAccess: function () {
      return this.propertyConfig.accessProps && this.propertyConfig.accessProps.surplusTransferConfirmationAccess && this.surplusTransferAvailable
    },
    surplusState: function () {
      return getToolRecordSurplusState(this.toolRecord, this.propertyConfig, this.surplusTransferFilesGroup)
    },
    filteredRegradingRecords: function () {
      let filteredRegradingRecords = this.regradingRecords && this.regradingRecords.filter(r => !r.removed) || []
      if (this.toolRecord) {
        filteredRegradingRecords = filteredRegradingRecords.filter(r => r.toolARecordId === this.toolRecord.id || r.toolBRecordId === this.toolRecord.id)
      }

      return filteredRegradingRecords
    },
    tool: function () {
      return this.toolRecord && this.toolRecord.tool || null
    },
    toolSerialNumber: {
      get: function () {
        return this.tool && this.tool.serialNumber || null
      },
      set: function (value) {
        if (this.tool && this.tool.id == null) {
          this.tool.serialNumber = value || null
        }
      }
    },
    toolInventoryNumber: {
      get: function () {
        return this.tool && this.tool.inventoryNumber || null
      },
      set: function (value) {
        if (this.tool && this.tool.id == null) {
          this.tool.inventoryNumber = value || null
        }
      }
    },
    isUnknownTool: function () {
      return !!(this.tool && this.tool.id == null)
    }
  },
  watch: {
    'toolRecord.unit': function () {
      const toolRecord = this.toolRecords.find(tR => tR.id === this.toolRecord.id)
      if (toolRecord != null) {
        toolRecord.unit = this.toolRecord.unit
      }
    },
    'toolRecord.amountReal': function () {
      const toolRecord = this.toolRecords.find(tR => tR.id === this.toolRecord.id)
      if (toolRecord != null) {
        toolRecord.amountReal = this.toolRecord.amountReal
      }
    },
    'toolRecord.amountDiff': function () {
      const toolRecord = this.toolRecords.find(tR => tR.id === this.toolRecord.id)
      if (toolRecord != null) {
        toolRecord.amountDiff = this.toolRecord.amountDiff
      }
    },
    'toolRecord.amountDiffType': function () {
      const toolRecord = this.toolRecords.find(tR => tR.id === this.toolRecord.id)
      if (toolRecord != null) {
        toolRecord.amountDiffType = this.toolRecord.amountDiffType
      }
    },
    filteredRegradingRecords: function () {
      const amountReal = this.$refs.amountReal
      if (amountReal) {
        amountReal.validate()
      }
    },
    filesGroup: {
      handler: function () {
        if (this.$refs.photo) {
          this.$refs.photo.validate()
        }
      },
      deep: true
    },
    surplusTransferFilesGroup: {
      handler: function () {
        if (this.$refs.surplusTransferPhoto) {
          this.$refs.surplusTransferPhoto.validate()
        }
      },
      deep: true
    }
  },
  created: function () {
    this.filesGroup.clear()
    if (this.toolRecord.photos) {
      this.filesGroup.pushFiles(this.toolRecord.photos.map(file => {
        return { id: file.id || file, name: (this.toolRecord.tool ? this.toolRecord.tool.name : 'Неизвестная позиция') + '-' + file.id || file }
      }))
    }

    this.surplusTransferFilesGroup.clear()
    if (this.toolRecord.surplusTransferPhotos) {
      this.surplusTransferFilesGroup.pushFiles(this.toolRecord.surplusTransferPhotos.map(file => {
        return { id: file.id || file, name: (this.toolRecord.tool ? this.toolRecord.tool.name : 'Неизвестная позиция') + '-' + file.id || file }
      }))
    } else {
      this.toolRecord.surplusTransferPhotos = []
    }
    this.amountRealOldValue = this.toolRecord.amountReal

    this.toolRecords = JSON.parse(JSON.stringify(this.request.toolRecords)) || []
    this.regradingRecords = JSON.parse(JSON.stringify(this.request.regradingRecords)) || []
  },
  mounted: function () {
    if (this.addSurplusTransferPhotos && this.$refs.filesFieldSurplusTransferPhotos) {
      this.$refs.filesFieldSurplusTransferPhotos.onAddFile()
    }
  },
  methods: {
    onAddSurplusTransferPhoto: function () {
      if (this.surplusTransferFilesGroup.hasFiles() && this.surplusTransferConfirmationAccess) {
        const user = this.$store.getters.getUser
        this.toolRecord.surplusTransferConfirmationTime = Date.now()
        this.toolRecord.surplusTransferConfirmationUser = user.name
      }
    },
    onInputSurplusConfirmation: function () {
      if (this.toolRecord.surplusTransferConfirmationTime) {
        this.toolRecord.surplusTransferConfirmationTime = null
        this.toolRecord.surplusTransferConfirmationUser = null
      } else {
        const user = this.$store.getters.getUser
        this.toolRecord.surplusTransferConfirmationTime = Date.now()
        this.toolRecord.surplusTransferConfirmationUser = user.name
      }
    },
    onInputSurplusTransfer: function () {
      if (this.toolRecord.surplusTransferTime) {
        this.toolRecord.surplusTransferTime = null
        this.toolRecord.surplusTransferUser = null
        this.toolRecord.surplusTransferConfirmationTime = null
        this.toolRecord.surplusTransferConfirmationUser = null
        this.surplusTransferFilesGroup.clear()
      } else {
        this.toolRecord.surplusTransferTime = Date.now()
        const user = this.$store.getters.getUser
        this.toolRecord.surplusTransferUser = user.name
      }
    },
    onInputWithdraw: function () {
      onWithdrawWithThis.call(this, this.toolRecord, this.filteredRegradingRecords)
    },
    onInputTool: function (tool) {
      if (tool && tool.id == null) { // Неизвестная позиция
        tool = {
          id: tool.id,
          name: tool.name,
          uniqueKey: null,
          partyNumber: null,
          partyName: null,
          serialNumber: null,
          serialKey: null,
          inventoryNumber: null
        }
      }

      this.toolRecord.tool = tool || null
      this.toolRecord.unit = tool && tool.unit || null
      this.toolRecord.amountRecorded = tool && tool.amount || 0

      // Для дополнительной добавленной уникальной позиции простаялем фактическое количество = 1
      if ((tool.serialNumber || tool.inventoryNumber) && this.toolRecord.amountReal == null) {
        this.onInputAmountReal(1, this.toolRecord)
      }

      this.$refs.photo.validate()

      if (!tool || tool.id == null) {
        const toolRecordId = this.toolRecord.id
        for (const regradingRecord of this.filteredRegradingRecords) {
          if (regradingRecord.toolARecordId === toolRecordId) {
            regradingRecord.toolA = tool
          } else {
            regradingRecord.toolB = tool
          }
        }
      }
    },
    hasChanges: function () {
      return this.toolRecordStr !== JSON.stringify(this.toolRecord) || this.filesGroup.hasChanges() || this.surplusTransferFilesGroup.hasChanges() || JSON.stringify(this.regradingRecords) !== JSON.stringify(this.request.regradingRecords) || JSON.stringify(this.toolRecords) !== JSON.stringify(this.request.toolRecords)
    },
    onSave: async function () {
      let valid = true

      let tool = this.toolRecord.tool || null
      if (!tool || tool.id == null) {
        const nameRegExp = /^Неизвестная позиция «(.*)»$/
        if (!tool || tool.name == null) {
          const unknownToolRecords = this.toolRecords.filter(r => r.id != this.toolRecord.id && (!r.tool || r.tool.id == null))

          let maxNumber = 0
          for (const unknownToolRecord of unknownToolRecords) {
            const toolName = unknownToolRecord.tool && unknownToolRecord.tool.name || null
            if (toolName) {
              const matchResult = toolName.match(nameRegExp)
              if (matchResult && matchResult.length) {
                const toolNumber = Number(matchResult[1])
                if (!isNaN(toolNumber) && toolNumber > maxNumber) {
                  maxNumber = toolNumber
                }
              }
            }
          }
          maxNumber++

          tool = {
            id: null,
            name: 'Неизвестная позиция «' + maxNumber + '»'
          }
        } else {
          const matchResult = tool.name.match(nameRegExp)
          if (!matchResult) {
            tool.name = 'Неизвестная позиция «' + tool.name + '»'
          }
        }

        this.toolRecord.tool = tool
      }

      const fields = ['tool', 'amountReal', 'unit', 'photo', 'surplusTransferPhoto']
      fields.forEach(field => {
        if (this.$refs[field] != null) {
          valid = this.$refs[field].validate() && valid
        }
      })

      if (!valid) {
        return
      }

      await this.uploadPhoto()

      if (!tool || tool.id == null) {
        const toolRecordId = this.toolRecord.id
        for (const regradingRecord of this.filteredRegradingRecords) {
          if (regradingRecord.toolARecordId === toolRecordId) {
            regradingRecord.toolA = tool
          } else {
            regradingRecord.toolB = tool
          }
        }
      }

      this.request.toolRecords = this.toolRecords
      this.request.regradingRecords = this.regradingRecords

      this.$emit('save', this.toolRecord)
    },
    uploadPhoto: async function () {
      if (this.filesGroup.hasChanges()) {
        await this.filesGroup.removeDeletedFiles({
          target: this
        })
        const result = await this.filesGroup.uploadFiles({
          notify: true,
          target: this
        })

        if (result) {
          const successFileResults = result.results.filter(item => item.status !== 'rejected')
          const successFileIds = successFileResults.map(item => item.value.data.id)
          this.toolRecord.photos = [...(this.toolRecord.photos || []), ...successFileIds]

          const rejectedFilesResults = result.results.filter(item => item.status === 'rejected')
          if (rejectedFilesResults.length) {
            throw Error('Ошибка сохранения фото')
          }
        }
      }

      if (this.surplusTransferFilesGroup.hasChanges()) {
        await this.surplusTransferFilesGroup.removeDeletedFiles({
          target: this
        })
        const result = await this.surplusTransferFilesGroup.uploadFiles({
          notify: true,
          target: this
        })

        if (result) {
          const successFileResults = result.results.filter(item => item.status !== 'rejected')
          const successFileIds = successFileResults.map(item => item.value.data.id)
          this.toolRecord.surplusTransferPhotos = [...(this.toolRecord.surplusTransferPhotos || []), ...successFileIds]

          const rejectedFilesResults = result.results.filter(item => item.status === 'rejected')
          if (rejectedFilesResults.length) {
            throw Error('Ошибка сохранения фото')
          }
        }
      }
    },
    onClose: function () {
      this.$emit('close')
    },
    onClear: function () {
      const refRegradingRecords = this.$refs.regradingRecords
      if (refRegradingRecords) {
        refRegradingRecords.onClear()
      }

      this.onInputAmountReal(null, this.toolRecord)

      this.toolRecord.surplusTransferTime = null
      this.toolRecord.surplusTransferUser = null
      this.toolRecord.surplusTransferConfirmationTime = null
      this.toolRecord.surplusTransferConfirmationUser = null
      this.surplusTransferFilesGroup.clear()
      this.filesGroup.clear()

      this.$set(this.toolRecord, 'edited', true)
    },
    onRemoveFile: function ({ file: fileWrapper, filesGroup }) {
      filesGroup.removeFile(fileWrapper)

      if (fileWrapper.document) {
        const photos = this.toolRecord.photos.filter(document => document.id !== fileWrapper.document.id)
        this.toolRecord.photos = photos
      }
    },
    onRemoveSurplusTransferPhotos: function ({ file: fileWrapper, filesGroup }) {
      filesGroup.removeFile(fileWrapper)

      if (fileWrapper.document) {
        const photos = this.toolRecord.surplusTransferPhotos.filter(document => document.id !== fileWrapper.document.id)
        this.toolRecord.surplusTransferPhotos = photos
      }

      this.toolRecord.surplusTransferConfirmationTime = null
      this.toolRecord.surplusTransferConfirmationUser = null
    }
  }
}

